import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";
import {appPath} from "@rw/cars_routes";
import {carsTheme} from "@rw/themes";
import {Dispatch} from "redux";

import {fetchAuthSession, logout as logoutSession} from "../admin/auth/auth_client";
import {Spinner} from "../app/components/Spinner";
import {IStore} from "../app/reducers/hybrid_reducer";
import {createRequestActionTypes} from "../app/utils/request_response_utils/factories/create_request_action_types";
import {postRequest} from "../app/utils/request_response_utils/request";
import {AddCar} from "./add_car/AddCar";
import {CarListTable} from "./car_list/CarListTable";
import {DashboardWrapper} from "./DashboardWrapper";

export interface IUserData extends JwtPayloadData {
    id: number;
}

export const setDashboardUserOffersTypes = createRequestActionTypes({name: "setUserOffers", type: "GET", view: "Dashboard"});
export const setUserToStoreTypes = createRequestActionTypes({name: "setUserToStore", type: "GET", view: "Dashboard"});

export const getUserOffers = (authorId: number) => async (dispatch: Dispatch) => {
    return postRequest({}, "/api/cars-by-author", {author_id: authorId})
        .then((res: any) => {
            dispatch({type: setDashboardUserOffersTypes.success, result: res});

            return res;
        })
        .catch((err) => {
            console.warn("err on reset", err);
        });
};

export interface JwtPayloadData {
    data: {
        user_id: number | null;
        display_name: string | null;
    };
    message?: string;
}

type DashViewType = "addOffer" | "showOffers";

export const DashboardDynamic = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const [user, setUser] = useState<{id: number | null; displayName: string | null}>({id: null, displayName: null});
    const [view, setDashboardView] = useState<DashViewType>("addOffer");
    const dispatch = useDispatch();
    const userOffers = useSelector((store: IStore) => store.dashboard.userOfferList);
    const [nonceCode, setNonceCode] = useState<string | null>(null);
    const handleDashView = (viewType: DashViewType) => {
        setDashboardView(viewType);
    };
    const logout = async () => {
        setIsAuthenticated(false);
        await logoutSession().catch(() => undefined);
        window.location.href = appPath.admin.login;
    };
    useEffect(() => {
        fetchAuthSession()
            .then((session) => {
                setNonceCode(session.nonce);
                setIsAuthenticated(session.authenticated);
                setUser(session.user);
                if (session.user.id) {
                    dispatch(getUserOffers(session.user.id));
                    dispatch({
                        type: setUserToStoreTypes.success,
                        result: {data: {user_id: session.user.id, displayName: session.user.displayName}}
                    });
                }
            })
            .catch(() => {
                setIsAuthenticated(false);
            });
    }, [dispatch]);

    if (isAuthenticated === null) {
        return (
            <DashboardWrapper>
                <div css={containerStyle}>
                    <span>Authoryzacja... </span>
                    <Spinner />
                </div>
            </DashboardWrapper>
        );
    }

    if (!isAuthenticated) {
        setTimeout(() => {
            window.location.href = appPath.admin.login;
        }, 3000);
        return (
            <DashboardWrapper>
                <div css={containerStyle}>Brak autoryzacji !</div>
            </DashboardWrapper>
        );
    }
    return (
        <DashboardWrapper>
            <p css={logoutStyle} onClick={logout}>
                {user.displayName ? user.displayName : null} Wyloguj
            </p>
            <div css={container}>
                <div css={aside}>
                    <ul css={asideNav}>
                        <li css={view === "addOffer" ? active : inactive} onClick={() => handleDashView("addOffer")}>
                            Dodaj ogłoszenie
                        </li>
                        <li css={view === "showOffers" ? active : inactive} onClick={() => handleDashView("showOffers")}>
                            Moje ogłoszenia
                        </li>
                    </ul>
                </div>
                <div css={contentWrapper}>
                    {view === "addOffer" && <AddCar user={user} nonce={nonceCode} />}
                    {view === "showOffers" && userOffers.length > 0 && <CarListTable cars={userOffers} />}
                </div>
            </div>
        </DashboardWrapper>
    );
};

const active = css`
    border-bottom: 2px solid ${carsTheme.colors.brand_primary};
    color: ${carsTheme.colors.brand_black};
`;
const inactive = css`
    border-bottom: 2px solid #fff;
    color: #000;
`;
const asideNav = (theme: Theme) => css`
    li {
        list-style: none;
        margin-bottom: 6px;

        &:hover {
            cursor: pointer;
            color: ${theme.colors.brand_primary};
        }
    }
`;
const contentWrapper = css`
    width: 100%;
`;
const aside = css`
    width: 300px;
    height: 100%;
    padding: 0 4rem 0 0;
`;

const container = css`
    max-width: 1190px;
    margin: 1rem auto;
    display: flex;
`;
const logoutStyle = (theme: Theme) => css`
    &:hover {
        color: ${theme.colors.brand_primary};
    }
`;

const containerStyle = css`
    padding: 4rem;
`;
